import axios from 'axios';
import { apiRoot } from '@/config/config'

// const apiRoot = 'https://material-design-platform.devindata.com/api';
export const apiRoot1 = 'http://localhost:3030/api';
const reactionRoot = 'http://114.215.46.133:8068';
const loginApi = 'https://api.devindata.com/login';

import userInfo from "@/Components/user";
const token = userInfo?.access_token;

export interface LoginParamsType {
  username: string;
  password: string;
  // platform: string;
  // type: string;
}

export async function physicalProps(data: any) {
  return await fetch(`${apiRoot}/zcphysicalprop?data=${JSON.stringify(data)}`, {
    // {"op":"basicinfo","CAS":"7664-41-7"}
    method: 'POST',
    // headers: {
    //   'content-type': 'application/json',
    // },
  });
}
export async function reactionCal(data: any, method: any) {
  return await fetch(`${reactionRoot}/reactor?data=${JSON.stringify(data)}`, {
    // {"op":"basicinfo","CAS":"7664-41-7"}
    method,
    // headers: {
    //   'content-type': 'application/json',
    // },
  });
}

export async function login(data: LoginParamsType) {
  const formBody = new URLSearchParams();
  formBody.append('username', data.username);
  formBody.append('password', data.password);

  return await fetch(`${apiRoot}/auth/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formBody,
  });
}
export async function getCurrentUser(token: string) {
  return await fetch(`${apiRoot}/users/me`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
// export async function login(data: LoginParamsType) {
//   return await fetch(`${loginApi}`, {
//     method: 'POST',
//     // mode: "cors",
//     headers: {
//       'content-type': 'application/json',
//     },
//     body: JSON.stringify(data),
//   });
// }
// export async function createJob(data: any) {
//   return await fetch(`${apiRoot}`, {
//     method: 'POST',
//     // mode: "cors",
//     headers: {
//       'content-type': 'multipart/form-data',
//     },
//     body: JSON.stringify(data)
//   });
// }

export async function createJob(data: any) {
  return await axios({
    url: `${apiRoot}/jobs`,
    method: 'post',
    data,
    headers: {
      'Content-Type':
        'multipart/form-data;boundary=----WebKitFormBoundaryVCFSAonTuDbVCoAN',
    },
  });
}

export async function listJobs(params: any) {
  return await axios({ url: `${apiRoot}/jobs`, method: 'GET', params });
}

export async function listPapers(params: any) {
  return await axios({ url: `${apiRoot}/papers`, method: 'GET', params });
}

export async function getResult(id: any) {
  return await axios({
    url: `${apiRoot}/jobs/${id}`,
    method: 'get',
  });
}

export async function delJob(id: any) {
  return await axios({
    url: `${apiRoot}/jobs/${id}`,
    method: 'delete',
  });
}

export async function uploadFile(formData: FormData, token: string) {
  return await fetch(`${apiRoot}/files`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization': `Bearer ${token}`,
      // 'Content-Type': 'multipart/form-data',
    },
    body: formData,
  });
}
export async function getMolInfo(formData: FormData) {
  return await fetch(`${apiRoot}/mol/details`, {
    method: 'POST',
    mode: 'cors',
    body: formData,
  });
}

export async function projectsAll(params: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects/listConnect`,
    method: 'GET',
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      // "Authorization": "Bearer token_for_dev",
      'Content-Type': 'application/json',
    },
  })
}
//项目列表
export async function projects(params: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects`,
    method: 'GET',
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      // "Authorization": "Bearer token_for_dev",
      'Content-Type': 'application/json',
    },
  });
}

//项目数据结构
type ProjectData = {
  name: string;
  description?: string;
  owner_id: number;
  thumbnail_url: string | null
};

//创建项目
export async function createProject(data: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects`,
    method: 'POST',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//更新项目
export async function updateProject(id: any, data: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects/${id}`,
    method: 'PUT',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//删除项目
export async function delProject(id: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects/${id}`,
    method: 'delete',
    // params:{id},
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//流程部分
//读取一条项目
export async function getProject(id: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects/${id}`,
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//读取一个项目的流程列表（flow）
export async function flows(project_id: any, params: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects/${project_id}/flows`,
    method: 'GET',
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//读取一个流程（flow）
export async function getFlow(project_id: any, flow_id: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects/${project_id}/flows/${flow_id}`,
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//保存流程（flow）
export async function saveFlow(project_id: any, flow_id: any, data: any, token: string) {
  return await fetch(`${apiRoot}/projects/${project_id}/flows/${flow_id}/save`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
}
//创建流程
export async function createFlow(project_id: any, data: any, token: string) {
  const subdata = {
    ...data,
    project_id
  }
  return await axios({
    url: `${apiRoot}/projects/${project_id}/flows`,
    method: 'POST',
    data: subdata,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//更新一个流程
export async function updateFlow(project_id: any, flow_id: any, data: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects/${project_id}/flows/${flow_id}`,
    method: 'PUT',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//删除流程
export async function delFlow(project_id: any, flow_id: any, token: string) {
  return await axios({
    url: `${apiRoot}/projects/${project_id}/flows/${flow_id}`,
    method: 'delete',
    // params:{id},
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//读取一个任务（jobs）
export async function getJob(id: any, token: string) {
  return await axios({
    url: `${apiRoot}/jobs/${id}`,
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

// export async function getJob(id: any,token:any) {
//   return await axios({
//     url: `${apiRoot}/jobs/${id}`,
//     method: 'GET',
//     headers: {
//       'Authorization': `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     },
//   });
// }


//读取任务列表（jobs）
export async function jobs(params: any, token: string) {
  return await axios({
    url: `${apiRoot}/jobs`,
    method: 'GET',
    params,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//更新job
export async function updateJob(job_id: any, data: any, token: string) {
  return await axios({
    url: `${apiRoot}/jobs/${job_id}`,
    method: 'PUT',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}

//创建任务（jobs）
export async function createJobs(data: any, tag: string, token: string) {
  return await axios({
    url: `${apiRoot}/jobs/${tag}`,
    method: 'POST',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
//删除Job
export async function deleteJob(id: any, token: string) {
  return await axios({
    url: `${apiRoot}/jobs/${id}`,
    method: 'delete',
    // params:{id},
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
export async function getFileList(page = 1, perPage = 1000) {
  return await axios({
    url: `${apiRoot}/elements`,
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    params: {
      page, // 页码
      perPage // 每页条数（接口要求的参数名）
    }
  });
}

export async function simulation(data: any,token: string) {
  return await axios({
    url: `${apiRoot}/jobs/simulation`,
    method: 'POST',
    data,
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });
}
export async function hydraulics(data: any,token: string) {
  return await axios({
    url: 'https://rto.devindata.com/api/hydraulics',
    method: 'POST',
    data,
    headers: {
      'Authorization': "Bearer devin-rto-api-key-2026",
      'Content-Type': 'application/json',
    },
  });
}